// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"aaf1748c1d22ef2c","6831":"fc977502297d5bc0","8503":"89e8d27ac118bd43","9683":"85113ab236d288b0"}[chunkId] + ".js";
};